import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

const loadDarkTheme = () => {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = "https://cdn.jsdelivr.net/npm/@sweetalert2/theme-dark/dark.css";
  link.id = "dark-theme";
  document.head.appendChild(link);
};

const removeDarkTheme = () => {
  const link = document.getElementById("dark-theme");
  if (link) {
    document.head.removeChild(link);
  }
};

const SwalConfig = (options) => {
  const themeMode = localStorage.getItem("theme");
  if (themeMode === "dark") {
    loadDarkTheme();
  } else {
    removeDarkTheme();
  }

  return Swal.fire({
    ...options,
    customClass: {
      popup: themeMode === "dark" ? "swal2-dark" : "",
      ...options.customClass,
    },
  });
};

export default SwalConfig;
